import { Injectable } from '@angular/core';
import { IQuotaTable } from '../models/IQuotaTable';
import { Observable } from 'rxjs/Observable';
import { FezaDataService } from './fezadata.service';
import { S1DataService } from './s1data.service';
//import { QAs } from '../models/QAs';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { IS1Question } from '../models/IS1Question';
import { IS1Answer } from '../models/IS1Answer';
import { IFizzyAnswer } from '../models/IFizzyAnswer';
import { IAnswer } from '../models/IAnswer';

@Injectable()
export class QuestionAnswerService {

  constructor(private s1: S1DataService, private fizzy: FezaDataService) {
  }

  questionLabelByIds(countryCode:string, locale: string, qId: number, aId:number): Observable<string>  {
    if (qId === -1)
      return Observable.of("Age Range");
    return this.s1.getQuestion(countryCode, locale, qId).map(q => q.name || `${qId}` );
  }

  answerLabel(answer: IAnswer): Observable<string> {
    if (answer.rangeEnd != null && answer.rangeStart != null) {
      return Observable.of(answer.rangeStart + " to " + answer.rangeEnd);
    }
    return this.fizzy.GetAnswer(answer.id).map(ans => ans.answerText);
  }

  questionLabelWAnswer(countryCode: string, locale: string, q: IS1Question, answers: IS1Answer[]): Observable<string> {
    //console.log(`questionLabelWAnswer country:${countryCode} locale:${locale} q:${q.id}`);
    //all these service calls are chaced with shareReplay
    if (q.id === -1)
      return Observable.of("Age Range");
    if (q === undefined || q.id === undefined)
      return Observable.of(`Undefined`);
    if (answers && answers.length && answers[0].listId > 0) {
      return this.fizzy.GetAnswer(answers[0].id).map(x => x.scriptingPlatformVariableAnswerName);
    }
    return this.s1.getQuestion(countryCode, locale, q.id).map(ques => {
      if (ques === undefined) {
        return `undefined:${q.id} countryCode:${countryCode} locale:${locale} q:${q.id}`;
      }
      return ques.name
    });

  }

  singleQuestionAnswerLabel(countryCode:string, locale:string, qId: number, aId: number): Observable<string> {
    if (qId === -1)
      return Observable.of("Age Range"); 
    return this.s1.getQuestion(countryCode, locale, qId).map(q => {
      for (let ans of q.answers) {
        if (ans.id == aId) {
          return `${q.name} ${ans.name} (${ans.text}/${ans.translation})`;
        }
      }
      return `${q.name} ${aId}`;
    });
  }

}




// WEBPACK FOOTER //
// ./src/app/services/question-answer-service.ts